import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Container,
  Title,
  Thanks,
  SmallInfo,
  AccountContainer,
  Info,
  Button,
  MainWrapper,
  OtherExperiences,
} from './summary.styles';
import messages from './summary.messages';
import { Divider } from '../../../shared/components/divider';
import { Card } from './card';
import { renderWhenTrue } from '../../../shared/utils/rendering';
import { GTMEvents, GTMList } from '../../../modules/analytics/analytics.constants';
import { REGISTER_TAB } from '../../../modules/auth/auth.constants';

export class Summary extends PureComponent {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    currentHomeRoute: PropTypes.string,
    sameMarketExperiencesLength: PropTypes.number,
    experience: PropTypes.object.isRequired,
    contextName: PropTypes.string.isRequired,
    isUserSignedIn: PropTypes.bool,
    logGTMEvent: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
    similarExperiences: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  handleViewportEnter = experiences =>
    this.props.logGTMEvent(GTMEvents.ViewedExperiences, { experiences, list: GTMList.Related });

  handleShowModal = () => this.props.showModal(REGISTER_TAB);

  render() {
    const {
      intl: { formatMessage },
      experience,
      sameMarketExperiencesLength,
      contextName,
      similarExperiences,
      isUserSignedIn,
    } = this.props;

    return (
      <Container>
        <MainWrapper>
          <Title>{formatMessage(messages.title)}</Title>
          <Thanks>{formatMessage(messages.thanks, { name: experience.name })}</Thanks>
          <Card renderImageOnce />
          <SmallInfo>{formatMessage(messages.preAuthorizationInfo)}</SmallInfo>
          {renderWhenTrue(() => (
            <AccountContainer>
              <Title noMargin>{formatMessage(messages.createAccount)}</Title>
              <Info>{formatMessage(messages.accountDescription)}</Info>
              <Button onClick={this.handleShowModal} dark>
                <FormattedMessage {...messages.buttonAccountLabel} />
              </Button>
            </AccountContainer>
          ))(!isUserSignedIn)}
        </MainWrapper>

        {renderWhenTrue(() => (
          <Fragment>
            <Divider horizontalPadding />

            <OtherExperiences
              visibilitySensorActive
              onViewportEnter={this.handleViewportEnter}
              title={formatMessage(messages.otherExperiences)}
              linkUrl={this.props.currentHomeRoute}
              linkLabel={formatMessage(messages.seeAllExperiences, {
                count: sameMarketExperiencesLength,
                market: contextName,
              })}
              experiences={similarExperiences}
              limitedCount
            />
          </Fragment>
        ))(similarExperiences.length > 0)}
      </Container>
    );
  }
}
